import React, { useEffect } from "react";
import { connect } from "react-redux";
import StockCard from "./StockCard";
import * as actions from "../../store/actions/index";
import Spinner from "../Spinner/Spinner";
import { constants } from "../../firebase/firestoreNameSpaces";

const StockManagementComponent = (props) => {
  useEffect(() => {
    props.onFetchStockOutProducts();
  }, []);

  if (props.loading) {
    return <Spinner />;
  }

  const handleUpdateStock = (productId, variantId, stock) => {
    props.onUpdateStock(productId, variantId, stock);
  };
  const getStockCard = () => {
    let cards = [];
    let stockOutProducts = props.stockOutProducts;
    if (stockOutProducts) {
      stockOutProducts.map((pObj) => {
        cards.push(
          <StockCard
            product={pObj}
            updateStock={(stock) =>
              handleUpdateStock(pObj.id, pObj.variantId, stock)
            }
            updateBtnLoading={props.updateBtnLoading}
          />
        );
      });
    }
    return cards;
  };

  return (
    <div className="container mt-4" style={{ width: "70%" }}>
      <h6 className="text-center">{`The Products with Quantity less than ${constants.STOCK_THRESHOLD} is shown`}</h6>
      <div className="text-center mt-3 mb-3">
        {props.stockOutProducts && (
          <h2>
            {props.stockOutProducts.length
              ? "Out Of Stock Products"
              : "Hurray! Everything In Stock"}
          </h2>
        )}
      </div>
      {getStockCard()}
      {/* <h1>{props.stockOutProducts?props.stockOutProducts[0].productTitle:"No product"}</h1> */}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.stock.loading,
    updateBtnLoading: state.stock.updateBtnLoading,
    stockOutProducts: state.stock.stockOutProducts,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchStockOutProducts: () => dispatch(actions.fetchStockOutProducts()),
    onUpdateStock: (productId, variantId, stock) =>
      dispatch(actions.updateStock(productId, variantId, stock)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StockManagementComponent);
